import { render, staticRenderFns } from "./ServiceCompany.vue?vue&type=template&id=232ade8d&"
import script from "./ServiceCompany.vue?vue&type=script&lang=js&"
export * from "./ServiceCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports